import React, { useEffect, useState, useCallback } from "react";
import TablePayroll from "components/TablePayroll";
import Title from "components/Title";
import * as S from "./styles";
import { useApi } from "hooks/useApis";
import { CircularProgress } from "@mui/material";
import { lightAmarelo } from "styles/variables";
import { FormProvider } from "react-hook-form";

const PayrollConsultation = () => {
  const api = useApi();

  const [payrollList, setPayrollList] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);

  const getPayrollListData = useCallback(
  async (pageNumber) => {
    try {
      setLoading(true);

      const data = await api.listPayrolls(
        pageNumber,
      );

      if (data && data.results) {
        setPayrollList(data.results);
        setTotalPages(data.total_pages);
      } else {
        console.error("Dados da API inválidos:", data);
      }
    } catch (err) {
      console.error("Erro ao buscar dados:", err);
    } finally {
      setLoading(false);
    }
  },
  [api]
);

  useEffect(() => {
    getPayrollListData(currentPage);
  }, [currentPage]);

  async function onSubmit(data) {
    try {
      if (currentPage !== 1) {
        setCurrentPage(1);
      }
    } catch (err) {
      console.error(err);
    }
  }

  function onError(errors) {
    console.log("Failed to submit:", errors);
  }


  return (
    <S.PageContainer>
      <Title
        subtitleTexts={["Início", "Consulta das folhas de pagamento"]}
        titleText="Consulta das folhas de pagamento"
      />
      <S.Subtitle>As folhas de pagamento sempre são geradas ao final de cada mês. </S.Subtitle>
      <S.PageContent>
        <S.MainContainer>
          <FormProvider>
            <S.Form onSubmit={(onSubmit, onError)}></S.Form>
          </FormProvider>

          {loading ? (
            <div
              style={{
                width: "100%",
                height: "50%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <CircularProgress style={{ color: lightAmarelo }} />
            </div>
          ) : (
            <TablePayroll
              payrollList={payrollList}
              page={currentPage}
              totalPages={totalPages}
              setPage={setCurrentPage}
            />
          )}

        </S.MainContainer>
      </S.PageContent>
    </S.PageContainer>
  );
};

export default PayrollConsultation;
